import { useEffect } from 'react';
import { Center, Spinner, Text, VStack } from '@chakra-ui/react';
import { Trans } from '@lingui/react/macro';
import { useAuthTenant } from './useAuthTenant';

/**
 * SignOut component that handles GET requests to /signout
 * Clears the user's session and redirects to the login page
 */
export function SignOut() {
  const { signOut } = useAuthTenant();

  useEffect(() => {
    // Automatically sign out when component mounts
    void signOut();
  }, [signOut]);

  return (
    <Center h="100vh">
      <VStack spacing={4}>
        <Spinner size="xl" />
        <Text>
          <Trans>Signing out...</Trans>
        </Text>
      </VStack>
    </Center>
  );
}
